<div class="flex justify-center items-center w-full h-[200px]">
    <div class="flex flex-col items-center font-bold text-white text-[40px]">
        <p>Ooops!</p>
        <p>{{'FAIL_PAGE.Etwas ist schief gelaufen.' | translate}}</p>
        <p>{{'FAIL_PAGE.Bitte versuchen Sie es erneut' | translate}}: <a href="{{website}}/" class="underline">"{{'MENU.home' | translate}}."</a></p>
    </div>
</div>